import { render, staticRenderFns } from "./Collateral.vue?vue&type=template&id=5d210caa&scoped=true&"
import script from "./Collateral.vue?vue&type=script&lang=js&"
export * from "./Collateral.vue?vue&type=script&lang=js&"
import style0 from "./Collateral.vue?vue&type=style&index=0&id=5d210caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d210caa",
  null
  
)

export default component.exports